<script setup>
import { Link } from "@inertiajs/inertia-vue3";
import BreezeApplicationLogo from "@/Components/ApplicationLogo.vue";
import BreezeNavLink from "@/Components/NavLink.vue";
import BreezeNavLinkHRef from "@/Components/NavLinkHRef.vue";
import BreezeResponsiveNavLink from "@/Components/ResponsiveNavLink.vue";
import Dropdown from "@/Components/Dropdown.vue";
import DropdownLink from "@/Components/DropdownLink.vue";
import { ref, onMounted } from "vue";

const showingNavigationDropdown = ref(true);
const appointmentInquiryCount = ref(0);

// get appointment inquiry count on page load
onMounted(() => {
  axios
    .get("/einstellungen/widget/inquiryCount")
    .then((response) => {
      appointmentInquiryCount.value = response.data;
    })
    .catch((error) => {
      console.error(error);
    });
});
</script>

<template>
  <nav class="bg-white navbar top-0 z-50">
    <!-- Primary Navigation Menu -->
    <div class="w-full flex">
      <div class="bg-oteo-300 px-7 py-1">
        <Link href="/">
          <BreezeApplicationLogo class="w-20 h-8" />
        </Link>
      </div>
      <div
        class="w-full text-sm pl-3 flex border-l border-l-oteoText bg-oteoNavGray"
      >
        <div class="flex">
          <Dropdown>
            <template #trigger>
              <div class="">Kalender</div>
            </template>

            <template #content>
              <div class="divide-y divide-gray-200">
                <div class="">
                  <DropdownLink
                    :href="'/kalender?ansicht=tag_behandler'"
                    method="get"
                  >
                    Tagesplaner
                  </DropdownLink>

                  <DropdownLink
                    :href="'/kalender?ansicht=woche_behandler'"
                    method="get"
                  >
                    Wochenplaner
                  </DropdownLink>
                </div>

                <div class="">
                  <DropdownLink :href="'/termin-erstellen'" method="get">
                    Termin erstellen
                  </DropdownLink>
                </div>

                <div class="">
                  <DropdownLink :href="'/termin-suchen'" method="get">
                    Terminsuche
                  </DropdownLink>
                  <DropdownLink :href="'/termin-finden'" method="get">
                    Patiententermine
                  </DropdownLink>
                </div>
              </div>
            </template>
          </Dropdown>

          <Dropdown>
            <template #trigger>
              <div class="">Grundeinstellungen</div>
            </template>

            <template #content>
              <div class="divide-y divide-gray-200">
                <div class="">
                  <DropdownLink :href="'/einstellungen'" method="get">
                    Stammdaten
                  </DropdownLink>
                </div>
                <div class="">
                  <DropdownLink :href="'/einstellungen/einheit'" method="get">
                    Einheiten der Arbeitszeit
                  </DropdownLink>
                  <DropdownLink
                    :href="'/einstellungen/behandlungszeiten'"
                    method="get"
                  >
                    Behandlungszeiten
                  </DropdownLink>
                  <DropdownLink :href="'/einstellungen/urlaub'" method="get">
                    Urlaub
                  </DropdownLink>
                  <DropdownLink :href="'/einstellungen/notdienst'" method="get">
                    Notdienst
                  </DropdownLink>
                  <DropdownLink
                    :href="'/einstellungen/sondertermine'"
                    method="get"
                  >
                    Sondertermine
                  </DropdownLink>
                </div>
                <div class="">
                  <DropdownLink
                    :href="'/einstellungen/behandlerinnen'"
                    method="get"
                  >
                    Behandler/innen
                  </DropdownLink>
                  <DropdownLink
                    :href="'/einstellungen/behandlungsraeume'"
                    method="get"
                  >
                    Behandlungsräume
                  </DropdownLink>
                  <DropdownLink
                    :href="'/einstellungen/behandlungstypen'"
                    method="get"
                  >
                    Behandlungstypen
                  </DropdownLink>
                  <DropdownLink
                    :href="'/einstellungen/behandlungsgruppen'"
                    method="get"
                  >
                    Behandlungsgruppen
                  </DropdownLink>
                </div>
                <div class="">
                  <DropdownLink
                    :href="'/einstellungen/nutzerverwaltung'"
                    method="get"
                  >
                    Nutzerverwaltung
                  </DropdownLink>
                  <DropdownLink
                    :href="'/einstellungen/rollenverwaltung'"
                    method="get"
                  >
                    Rollenverwaltung
                  </DropdownLink>
                  <!-- <DropdownLink :href="'/einstellungen/'" method="get">
                    Patientennamen ausblenden
                  </DropdownLink> -->
                  <DropdownLink
                    :href="'/einstellungen/terminservice'"
                    method="get"
                  >
                    Terminservice
                  </DropdownLink>
                  <DropdownLink
                    :href="'/einstellungen/terminzettel'"
                    method="get"
                  >
                    Terminzettel
                  </DropdownLink>
                </div>
                <div class="">
                  <DropdownLink :href="'/einstellungen/design'" method="get">
                    Design
                  </DropdownLink>

                  <DropdownLink
                    v-if="$page.props.auth.office_canusewidget"
                    :href="'/einstellungen/widgeteinbindung'"
                    method="get"
                  >
                    Online-Terminvergabe
                  </DropdownLink>

                  <DropdownLink
                    v-else
                    :href="'/einstellungen/widget/bestellen'"
                    method="get"
                  >
                    Online-Terminvergabe
                  </DropdownLink>

                  <DropdownLink
                    :href="'/einstellungen/integration'"
                    method="get"
                  >
                    Integration
                  </DropdownLink>
                </div>
              </div>
            </template>
          </Dropdown>

          <BreezeNavLinkHRef target="blank" href="/hilfe">
            Hilfe
          </BreezeNavLinkHRef>

          <form method="post" action="/logout">
            <input
              type="hidden"
              name="_token"
              :value="$page.props.csrf_token"
            />
            <button
              type="submit"
              class="inline-flex items-center px-4 font-medium leading-5 text-white h-full hover:bg-oteo-300 transition duration-150 ease-in-out"
            >
              Logout
            </button>
          </form>

          <!-- <BreezeNavLink href="/logout" method="delete"> Logout </BreezeNavLink> -->
        </div>

        <div class="ml-auto flex">
          <a
            v-if="
              appointmentInquiryCount && $page.props.auth.office_canusewidget
            "
            class="cursor-pointer inline-block rounded-full shadow-sm bg-red-500 w-7 h-7 leading-7 text-center text-white self-center mx-3"
            href="/einstellungen/widgetanfragen"
          >
            {{ appointmentInquiryCount }}
          </a>

          <div
            v-if="$page.props.auth.office_name"
            class="flex items-center text-white leading-5 px-4 bg-oteoText"
          >
            {{ $page.props.auth.office_name }}
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>
